export interface BulkActionFailure {
  email_id: string;
  code: string;
  message: string;
}

export interface BulkActionResponse {
  updated_email_ids?: string[];
  failed?: BulkActionFailure[];
}

export interface BulkActionOutcome {
  failedIds: string[];
  type: 'success' | 'warning' | 'error';
  message: string;
}

const emailLabel = (count: number) => `email${count === 1 ? '' : 's'}`;

export const getBulkActionOutcome = (
  selectedIds: string[],
  response: BulkActionResponse,
): BulkActionOutcome => {
  const failedIdSet = new Set((response.failed || []).map(({email_id}) => email_id));
  const failedIds = selectedIds.filter((emailId) => failedIdSet.has(emailId));
  const failedCount = failedIds.length;
  const selectedCount = selectedIds.length;

  if (failedCount === 0) {
    return {
      failedIds: [],
      type: 'success',
      message: `Updated ${selectedCount} ${emailLabel(selectedCount)} successfully!`,
    };
  }

  return {
    failedIds,
    type: 'error',
    message: `We couldn't update ${failedCount} of the ${selectedCount} selected ${emailLabel(selectedCount)}. Please check and try again.`,
  };
};
